import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
import Repository from '@/app/repositories/repository'

const productRepository = RepositoryFactory.get('product');

export default Object.assign(productRepository, {
    getTopList: function(catalogId, itemsCount){
        return Repository.get(`${this.resource}/getTopList?catalogId=${catalogId}&itemsCount=${itemsCount}`);
    },
    getProductsByCatalogId: function(catalogId){
        return Repository.get(`/product/getProductsByCatalogId?catalogId=`+catalogId);
    },
    getAssetsByProductId: function(productId){
        return Repository.get(`/product/getAssetsByProductId?productId=`+productId);
    }
});
